






































































































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import UUIFComponent from '@/shared/uuifComponent';
import { SwTextarea } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { SwCheckbox } from '@libs-uuif/shared/sw-checkbox';
const cssPrefix = 'transfer-confirmation';

@Component({
  components: {
    ...UUIFComponent,
    SwTextarea,
    SwCheckbox,
  },
})
export default class TransferConfirmation extends SwExtendedVue {
  cssPrefix = cssPrefix;
  regularCheck : boolean = false;
  @Prop({ required: true })
  latestResponse : any;
  @Prop({ required: true })
  field : any;
  closeProductDetail() {
    this.$emit('cancelRegister');
  }
  confirm() {
    if (this.regularCheck) {
      this.$emit('closeModal');
      console.warn(this.field);
      console.warn(this.latestResponse.content.uniqueID);
      this.$store.commit('MswProductsStoreModule/mapMutate', { property: 'uniqueID', key:this.field , value:this.latestResponse.content.uniqueID });
      console.warn(this.$store.getters['MswProductsStoreModule/getUniqueID'].get(this.field));
      // const req = {
      //   arrSurveyResponse: [],
      //   authCode: this.latestResponse.authCode,
      //   awsAssignToken: '',
      //   countryCode: '',
      //   dataCenterLocationID: null,
      //   friendlyName: '',
      //   groupName: this.latestResponse.groupId,
      //   isUpgradeFreeTrial: '',
      //   isZTAplies: false,
      //   messageAccept: '',
      //   policyServerurl: null,
      //   productType: '',
      //   registeronly: true,
      //   replacementType: '',
      //   serialNumber: this.latestResponse.serialNumber,
      //   uniqueID: '',
      //   upgradeFreeTrialSerialnumber: '',
      //   username: this.$store.getters.getUserId,
      //   ztValue: null,
      // };
      // this.registerProduct(req);
    }
  }
  cancel() {
    this.$emit('cancelRegister' , '');
  }

  created() {
    console.warn(this.latestResponse);
    this.$store.commit('MswProductsStoreModule/mapMutate', { property: 'uniqueID', key:this.field , value: '' });
  }

  private openTermsandConditions() {
    window.open('https://www.sonicwall.com/legal/general-product-agreement/', '_blank');
  }

  registerProduct() {
    this.$emit('cancelRegister' , 'failed');
    // this.$store.commit('startLoading');
    // this.$store.dispatch('MswProductsStoreModule/registerSerialNumber', request)
    // .then((res) => {
    //   this.$store.commit('stopLoading');
    //   if (res.msgCode === 'MSWAPP:AUTHENTICATEAPT') {
    //     this.$store.commit('MswProductsStoreModule/mapMutate', { property: 'uniqueID', key:this.field , value: res.content.uniqueID });
    //     this.$emit('closeModal');
    //   } else {
    //     this.$emit('closeModal');
    //     this.$emit('cancelRegister' , 'failed');
    //   }
    // });
  }
}
